module.exports = __webpack_public_path__ + "static/media/istock_images.858b67d6.png";